
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/guides/[guide-id]",
      function () {
        return require("private-next-pages/docs/guides/[guide-id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/guides/[guide-id]"])
      });
    }
  